import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AffiliateProgramService } from '@/services/affiliate-program.service';
import { toast } from '@/hooks/use-toast';
import { useTranslation } from 'react-i18next';

export const useRemoveAffiliate = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('affiliates');

  return useMutation({
    mutationFn: (productInvitationId: string) =>
      AffiliateProgramService.removeAffiliate(productInvitationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['affiliates'] });
      toast({
        variant: 'success',
        description: t('affiliate_removed_success'),
      });
    },
    onError: () => {
      toast({
        variant: 'error',
        description: t('affiliate_removed_error'),
      });
    },
  });
};